<template>
  <div
    :class="['highlight', { 'is-primary': isPrimary }]"
    :title="infoLabel"
    :style="styles"
  />
  </div>
</template>

<style lang="scss">
 @import '@/assets/variables.scss';

 .highlight {
   position: absolute;

   background-color: $link-10;
   border: 2px solid $link-50;

   &.is-primary {
     background-color: $primary-10;
     border-color: $primary-20;
   }

   &.is-selected {
     border-color: $primary-50;
   }
 }
</style>

<script>
 import { rgbhash } from '@/utils/misc.js'

 export default {
   props: {
     id: String,
     rect: {
       type: Object,
       default: () => ({ x: 0, y: 0, width: 0, height: 0 })
     },
     label: {
       type: String,
       default: ''
     },
     score: {
       type: Number,
       default: 0
     },
     isPrimary: {
       type: Boolean,
       default: true
     }
   },
   computed: {
     infoLabel() {
       return `${this.label}`
     },
     prettyScore() {
       return Math.round(this.score * 100) / 100
     },
     styles() {
       const { x, y, width, height } = this.rect
       return {
         left: `${x}%`,
         top: `${y}%`,
         width: `${width}%`,
         height: `${height}%`,
         // borderColor: this.getColorFromString(this.label, 0.0875),
         // backgroundColor: this.getColorFromString(this.label, 0.0275)
       }
     }
   },
   methods: {
     getColorFromString(string, opacity) {
       const rgb = rgbhash(string)
       return `rgb(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, ${opacity})`      
     }
   }
 }
</script>
